/**
 * Detects KakaoTalk, LINE, Facebook, Instagram and other in-app browsers
 * that block Google OAuth.
 */
export function isInAppBrowser(): boolean {
  const ua = navigator.userAgent || '';
  const inAppKeywords = [
    'KAKAOTALK', 'NAVER', 'Line/', 'FBAN', 'FBAV', 'Instagram',
    'Twitter', 'MicroMessenger', 'WebView', 'wv',
  ];
  return inAppKeywords.some((kw) => ua.toUpperCase().includes(kw.toUpperCase()));
}

/**
 * Attempts to open the current URL in an external browser.
 * Works on Android (intent://), iOS falls back to window.open.
 */
export function openInExternalBrowser(url?: string): void {
  const targetUrl = url || window.location.href;

  // Android: intent scheme opens the default browser
  const isAndroid = /android/i.test(navigator.userAgent);
  if (isAndroid) {
    window.location.href =
      `intent://${targetUrl.replace(/^https?:\/\//, '')}#Intent;scheme=https;end`;
    return;
  }

  // iOS / fallback: open in a new window (Safari)
  window.open(targetUrl, '_blank');
}
